import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Background from "../Components/Background";
import MovieCard from "../Components/MovieCard";
import List from "./List";
const ListView = () => {
  const [List, setList] = useState();
  const location = useLocation();
  useEffect(() => {
    setList(location.state);
  }, []);

  return (
    <div>
      <div className="z-40 relative mt-8">
        {List && List.items.length !== 0 ? (
          <div className="flex flex-col px-4">
            <div className="newfont uppercase mb-1 text-lg font-extrabold md:text-xl lg:text-2xl 2xl:text-4xl inline-block text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text my-4">
              {List.listName}
            </div>
            <div className="newfonttwo text-slate-300 my-2 ">
              {List.listDescription}
            </div>
            <div className="flex flex-row flex-wrap">
              {List.items.map((e) => (
                <div>
                  <MovieCard
                    movie={{
                      name: e.name,
                      id: e.tvid || e.movieid,
                      profile_path: e.posterImage,
                    }}
                    filterType={
                      e.movieid
                        ? { isMovieChecked: true }
                        : { isTvChecked: true }
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <Background />
    </div>
  );
};

export default ListView;
